// Lib
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import classNames from 'classnames';

// Components
import ToolbarTool from '../ToolbarTool';
import Icon from '../../../../components/icons/Icon';

// Actions
import { startAnnotationMode } from '../../../../element/drawing/annotation/store/annotationActions';
import { getIsAnnotationModeEnabled } from '../../../../element/drawing/annotation/store/annotationSelector';

const mapStateToProps = createStructuredSelector({
    isAnnotationMode: getIsAnnotationModeEnabled,
});

const mapDispatchToProps = (dispatch) => ({
    onStartDrawingMode: () => dispatch(startAnnotationMode()),
});

const DrawingTool = ({ onStartDrawingMode, isAnnotationMode }) => (
    <ToolbarTool
        className={classNames('DrawingTool', { open: isAnnotationMode })}
        name="Draw"
        onClick={onStartDrawingMode}
    >
        <Icon name="toolbar-draw" />
    </ToolbarTool>
);

DrawingTool.propTypes = {
    onStartDrawingMode: PropTypes.func,
    isAnnotationMode: PropTypes.bool,
};

export default connect(mapStateToProps, mapDispatchToProps)(DrawingTool);
